export const formatToTwoDecimalPlacesIfNotWholeNumber = (x: number) => {
    return (x).toFixed(2).replace(/[.,]00$/, "");
};